import { render, staticRenderFns } from "./LogMediaTier.vue?vue&type=template&id=3798d70f&"
import script from "./LogMediaTier.vue?vue&type=script&lang=js&"
export * from "./LogMediaTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports